import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import home from './modules/home/home'
import wx from './modules/wx'
import solution from './modules/solutions/solution'
import baseData from './modules/base_data'
import demand from './modules/demands/demand'

Vue.use(Vuex)

const state = {}

const actions = {}

const mutations = {}
/* 可单独抽取一个getter文件 */
const getters = {
  /* 导航菜单 */
  getMenu: () => {
    return {
      home: process.env.MENU.HOME_URL,
      category: process.env.MENU.CATEGORY_URL,
      mall: process.env.MENU.MALL_URL,
      member: process.env.MENU.MEMBER_URL
    }
  }
}

export default new Vuex.Store({
  state,
  actions,
  mutations,
  getters,
  modules: {
    user,
    home,
    wx,
    solution,
    baseData,
    demand
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js